import React from "react";
import { calculateFontSizeForTextContent } from "@utility/index";

export default function TextPost({ post }) {
  const fontSize = calculateFontSizeForTextContent({
    textLength: post.text?.length,
    maxFontSize: 25,
  });

  return (
    <div
      className="bg-[#0f0e12] w-full flex justify-center h-screen"
      style={{ height: "100vh", maxHeight: "-webkit-fill-available" }}
    >
      <div
        className="w-full flex justify-center items-center lg:w-[600px]"
        style={{ height: "100vh", maxHeight: "-webkit-fill-available" }}
      >
        <p
          className="text-[#edecf2] max-w-full break-words px-2 lg:px-0 "
          style={{ fontSize }}
        >
          {post.text}
        </p>
      </div>
    </div>
  );
}
